import { resolveBrand } from '@/config/branding';
import { cn } from '@/lib/utils';

type AuthBrandLogoProps = {
  className?: string;
};

export const AuthBrandLogo = ({ className }: AuthBrandLogoProps) => {
  const brand = resolveBrand();

  return (
    <img
      src={brand.authLogo}
      alt={`${brand.name} Logo`}
      className={cn(
        'h-14 w-auto object-contain',
        brand.authLogoBgClass,
        className,
      )}
    />
  );
};
